<template>
  <logged-in-layout>
    <main v-if="ready">
      <h1>SMS</h1>

      <contact
        v-if="customer"
        :name="customer.name"
        :photoUrl="customer.photoUrl"
        :phoneNumber="phoneNumber"
        :contact="contact" />

      <sms-window
        :recipient="phoneNumber.number"
        :prospectId="prospectId"
        :objectType="objectType"
        :deviceId="deviceId" />
    </main>
  </logged-in-layout>
</template>

<script>
  import axios from 'axios'
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import Contact from './contact/contact'
  import SmsWindow from './sms-window/sms-window'

  export default {
    components: {
      Contact,
      LoggedInLayout,
      SmsWindow
    },
    data () {
      return {
        ready: false,
        phoneNumber: null,
        prospectId: this.$route.query.prospectId,
        objectType: this.$route.query.objectType,
        deviceId: store.get('deviceId'),
        customer: null
      }
    },
    computed: {
      contact () {
        if (!this.customer) {
          return null
        }

        return {
          crmId: this.customer.crmId,
          prospectType: this.objectType
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        if (this.prospectId) {
          await Promise.all([
            this.retrieveCustomerByProspectId(),
            this.retrievePhoneNumber()
          ])
        } else {
          await this.retrieveCustomerByPhoneNumber()
        }

        this.ready = true
      },
      async retrieveCustomerByProspectId () {
        try {
          const response = await axios.get(`${jiminnyHost()}/api/v1/crm/customers`, {
            params: {
              providerId: this.prospectId,
              objectType: this.objectType
            }
          })
          this.customer = response.data
        } catch (error) {
          const { status, data } = error.response

          const errorMessage = status === 503
            ? data.message
            : 'To text this number please try again from the main Lead, Contact or Account page'

          this.showError(errorMessage)
        }
      },
      async retrievePhoneNumber () {
        try {
          const response = await axios.get(`${jiminnyHost()}/api/v1/phone-numbers/${this.$route.query.to}`)
          this.phoneNumber = response.data
        } catch (error) {
          this.showError(`Invalid phone number: ${this.$route.query.to}`)
        }
      },
      async retrieveCustomerByPhoneNumber () {
        try {
          await this.retrievePhoneNumber()

          const response = await axios.get(`${jiminnyHost()}/api/v1/crm/customers`, {
            params: {
              phoneNumber: this.phoneNumber.number
            }
          })
          this.customer = response.data
        } catch (error) {
          const { status, data } = error.response

          if (status !== 404) { // 404 means we are in SMS in free-dial mode
            this.showError(data.message)
          }
        }
      },
      showError (error) {
        this.$router.push({
          path: '/error-page',
          query: {
            error: encodeURIComponent(error)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// sms.vue?6b82625c